import { useQuery } from '@tanstack/react-query';

import { fetchLastActivities } from '@/api/v4/last-activities.api';
import { QueryKey } from '@/config/query-client';

import { recentItemsTypeState } from '../recent-items.state';
import { useAtomValue } from 'jotai';

export const useLastActivities = () => {
  const selectedRecentItemsType = useAtomValue(recentItemsTypeState);

  const fetchLastUserActivities = () => {
    const params =
      selectedRecentItemsType === 'all'
        ? undefined
        : { type: selectedRecentItemsType };

    return fetchLastActivities(params);
  };

  return useQuery({
    queryKey: [QueryKey.LastActivities, selectedRecentItemsType],
    queryFn: fetchLastUserActivities,
    staleTime: 1000 * 60 * 5,
  });
};
